import React from 'react';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import { Toggle } from '@components/Toggle';

import styles from './SettingToggleCard.module.scss';

/**
 * Bordered "enable X for company"-style settings card: title + description
 * on the left, a status label + Toggle on the right, with optional content
 * (e.g. an info Callout) rendered below once expanded/enabled.
 */
export const SettingToggleCard = ({
  title,
  description,
  checked,
  onChange,
  statusLabel,
  disabled,
  children,
}) => (
  <div className={styles.card}>
    <div className={styles.headerRow}>
      <div className={styles.textStack}>
        <Text
          variant={textVariantsEnum.Text_md}
          fontWeight={fontWeightEnum.Semibold}
          color="gray-900"
        >
          {title}
        </Text>
        {description && (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            color="gray-600"
          >
            {description}
          </Text>
        )}
      </div>
      <div className={styles.control}>
        {statusLabel && (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
            color="gray-700"
          >
            {statusLabel}
          </Text>
        )}
        <Toggle checked={checked} onChange={onChange} disabled={disabled} />
      </div>
    </div>
    {children && <div className={styles.body}>{children}</div>}
  </div>
);

SettingToggleCard.displayName = 'SettingToggleCard';
